import { isWorker } from '@frameio/utils/config/helpers';
import { reportError as datadogReportError } from './datadog/reportError';
import { WORKER_ERROR_EVENT } from './types';

export function reportError(error: any, context?: object) {
  if (isWorker) {
    self.postMessage({
      eventType: WORKER_ERROR_EVENT,
      payload: JSON.stringify(error, Object.getOwnPropertyNames(error)),
    });
  } else {
    datadogReportError(error, context);
  }
}
